import { render, staticRenderFns } from "./PreProfilesHandoverInfo.vue?vue&type=template&id=8ab5b03a"
import script from "./PreProfilesHandoverInfo.vue?vue&type=script&lang=js"
export * from "./PreProfilesHandoverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports